<template>
  <div class="box" v-if="settings">
    <b-field label="Телефон">
      <b-input v-model="settingsObject.phone" @change="handleUpdate"/>
    </b-field>
    <b-field label="Почта для ЛК">
      <b-input v-model="settingsObject.siteEmail" @change="handleUpdate"/>
    </b-field>
    <b-field label="Почта для заявок на договор (через запятую)">
      <b-input v-model="settingsObject.requestsEmail" @change="handleUpdate"/>
    </b-field>
    <b-field label="Почта для заявок на вебинар (через запятую)">
      <b-input v-model="settingsObject.webinarsEmail" @change="handleUpdate"/>
    </b-field>
    <b-field label="Почта для заявок на мероприятия (через запятую)">
      <b-input v-model="settingsObject.eventsEmail" @change="handleUpdate"/>
    </b-field>
    <b-field label="Адрес (в подвал)">
      <b-input type="textarea" v-model="settingsObject.address" @change="handleUpdate"/>
    </b-field>
    <b-field label="Копирайты, лицензии">
      <Editor v-model="text" :editorToolbar="customToolbar" />
    </b-field>
    <h3>Социальные сети</h3>
    <div class="social">
      <!-- <p>
        <img src="/static/img/icons/social/facebook.svg" />
        <b-input @change="handleUpdate" v-model="settingsObject.social.facebook" />
      </p> -->
      <p>
        <img src="/static/img/icons/social/vk.svg" />
        <b-input @change="handleUpdate" v-model="settingsObject.social.vk"/>
      </p>
      <p>
        <img src="/static/img/icons/social/youtube.svg" />
        <b-input @change="handleUpdate" v-model="settingsObject.social.youtube"/>
      </p>
      <p>
        <img src="/static/img/icons/social/ok.svg" />
        <b-input @change="handleUpdate" v-model="settingsObject.social.ok"/>
      </p>
      <p>
        <img src="/static/img/icons/social/rutube.svg" />
        <b-input @change="handleUpdate" v-model="settingsObject.social.rutube"/>
      </p>
      <p>
        <img src="/static/img/icons/social/telegram.svg" />
        <b-input @change="handleUpdate" v-model="settingsObject.social.telegram"/>
      </p>
      <!-- <p>
        <img src="/static/img/icons/social/instagram.svg" />
        <b-input @change="handleUpdate" v-model="settingsObject.social.instagram"/>
      </p> -->
    </div>
    <h3>Документы</h3>
    <div class="settings-files">
      <p>
        <strong>Политика защиты:</strong>
        <span class="link" v-if="!settings.securityPolicyFile" @click="$refs.loadPolicyButton.click()">Загрузить</span>
        <span v-else>
          <a :href="settings.securityPolicyFile" target="_blank">{{ settings.securityPolicyFile | formatFileName }}</a>
          <span class="delete-document" @click="deletePolicyFile()">X</span>
        </span>
        <input type="file" @change='handleLoadPolicyFile' hidden ref="loadPolicyButton"/>
      </p>
      <p>
        <strong>Согласие на обработку данных:</strong>
        <span class="link" v-if="!settings.agreementFile" @click="$refs.loadAgreementButton.click()">Загрузить</span>
        <span v-else>
          <a :href="settings.agreementFile" target="_blank">{{ settings.agreementFile | formatFileName }}</a>
          <span class="delete-document" @click="deleteAgreementFile()">X</span>
        </span>
        <input type="file" @change='handleLoadAgreementFile' hidden ref="loadAgreementButton"/>
      </p>
      <p>
        <strong>СОГЛАСИЕ на получение информации и рассылок:</strong>
        <span class="link" v-if="!settings.infoMailingFile" @click="$refs.loadInfoMailingButton.click()">Загрузить</span>
        <span v-else>
          <a :href="settings.infoMailingFile" target="_blank">{{ settings.infoMailingFile | formatFileName }}</a>
          <span class="delete-document" @click="deleteInfoMailingFile()">X</span>
        </span>
        <input type="file" @change='handleLoadInfoMailingFile' hidden ref="loadInfoMailingButton"/>
      </p>
      <p>
        <strong>Согласие на обработку персональных данных при проведении депозитарием:</strong>
        <span class="link" v-if="!settings.depositoryConsentFile" @click="$refs.loadDepositoryConsentButton.click()">Загрузить</span>
        <span v-else>
          <a :href="settings.depositoryConsentFile" target="_blank" rel="noopener noreferrer">{{ settings.depositoryConsentFile | formatFileName }}</a>
          <span class="delete-document" @click="deleteDepositoryConsentFile()">X</span>
        </span>
        <input type="file" @change="handleLoadDepositoryConsentFile" hidden ref="loadDepositoryConsentButton"/>
      </p>
    </div>
    <h3>Меню в подвале</h3>
    <div class="is-flex footer-menu-generator">
      <div>
        <strong>Левый столбец</strong>
        <draggable v-model="leftFooterItems">
          <FooterItem v-for="item in leftFooterItems" :key="item.id" :item="item"/>
        </draggable>
        <div class="centered">
          <span class="button-wrapper" @click="addToLeftColumn">
            <a class="button is-info">+</a>Добавить элемент
          </span>
        </div>
      </div>
      <div>
        <strong>Правый столбец</strong>
        <draggable v-model="rightFooterItems">
          <FooterItem v-for="item in rightFooterItems" :key="item.id" :item="item"/>
        </draggable>
        <div class="centered">
          <span class="button-wrapper" @click="addToRightColumn">
            <a class="button is-info">+</a>Добавить элемент
          </span>
        </div>
      </div>
    </div>
    <div class="save-content-button centered">
      <button class="button save-content" @click="handleSaveSetting()" :disabled="disabled">{{ disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ' }}</button>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import deepcopy from 'deepcopy'
import FooterItem from 'components/Settings/FooterItem'
import draggable from 'vuedraggable'
import { VueEditor as Editor } from 'vue2-editor'
import uuidv4 from 'uuid/v4'

export default {
  name: 'Settings',
  data () {
    return {
      updateTimer: null,
      disabled: false,
      text: '',
      customToolbar: [
        ['link']
      ],
      maxFooterItemOrder: null
    }
  },
  computed: {
    ...mapState(['settings']),
    settingsObject () {
      this.text = this.settings.copyrights
      if (!this.maxFooterItemOrder) {
        this.maxFooterItemOrder = this.settings.footerItems.length
      }
      return deepcopy(this.settings)
    },
    leftFooterItems: {
      get () {
        return this.settings ? deepcopy(this.settings.footerItems.filter(i => i.position === 'left')) : []
      },
      set (val) {
        for (let i = 0; i < val.length; i++) {
          val[i].order = i
        }
        this.updateAllFooterItems([...val, ...this.rightFooterItems])
      }
    },
    rightFooterItems: {
      get () {
        return this.settings ? deepcopy(this.settings.footerItems.filter(i => i.position === 'right')) : []
      },
      set (val) {
        for (let i = 0; i < val.length; i++) {
          val[i].order = i
        }
        this.updateAllFooterItems([...val, ...this.leftFooterItems])
      }
    }
  },
  methods: {
    ...mapActions(['saveSettings', 'getSettings', 'addFooterItem', 'updateSettings',
      'updateAllFooterItems', 'changePolicyFile', 'changeAgreementFile', 'changeInfoMailingFile', 'updateSettings',
      'deleteAgreementFile', 'deletePolicyFile', 'deleteInfoMailingFile', 'loadInfoMailingFile',
      'changeDepositoryConsentFile', 'deleteDepositoryConsentFile']),
    handleUpdate () {
      this.settingsObject.copyrights = this.text
      this.updateSettings(this.settingsObject)
    },
    handleSaveSetting () {
      this.disabled = true
      this.saveSettings(this.settingsObject)
      .then(() => {
        this.disabled = false
        this.$toast.open({ message: 'Сохранено' })
      })
      .catch(() => {
        this.disabled = false
        this.$toast.open({ message: 'Не удалось сохранить настройки', type: 'is-danger' })
      })
    },
    addToLeftColumn () {
      this.maxFooterItemOrder += 1
      this.addFooterItem({ position: 'left', title: '', url: '', id: uuidv4(), setting_id: this.settings.id, order: this.maxFooterItemOrder })
    },
    addToRightColumn () {
      this.maxFooterItemOrder += 1
      this.addFooterItem({ position: 'right', title: '', url: '', id: uuidv4(), setting_id: this.settings.id, order: this.maxFooterItemOrder })
    },
    handleLoadPolicyFile (e) {
      const file = e.target.files[0]
      if (!file) return
      const formData = new FormData()
      formData.set('avatar', file)
      this.changePolicyFile(file.name)
      this.settingsObject.newPolicyFile = formData
      this.updateSettings(this.settingsObject)
      e.target.value = ''
    },
    handleLoadAgreementFile (e) {
      const formData = new FormData()
      const file = e.target.files[0]
      formData.set('avatar', file)
      this.changeAgreementFile(file.name)
      this.settingsObject.newAgreementFile = formData
      this.updateSettings(this.settingsObject)
    },
    handleLoadInfoMailingFile (e) {
      const formData = new FormData()
      const file = e.target.files[0]
      formData.set('avatar', file)
      this.changeInfoMailingFile(file.name)
      this.settingsObject.newInfoMailingFile = formData
      this.updateSettings(this.settingsObject)
    },
    handleLoadDepositoryConsentFile (e) {
      const file = e.target.files[0]
      if (!file) return
      const formData = new FormData()
      formData.set('avatar', file)
      this.changeDepositoryConsentFile(file.name)
      this.settingsObject.newDepositoryConsentFile = formData
      this.updateSettings(this.settingsObject)
      e.target.value = ''
    },
    // deleteInfoMailingFile () {
    //   this.deleteInfoMailingFile()
    //   this.settingsObject.infoMailingFile = ''
    //   this.settingsObject.newInfoMailingFile = null
    //   this.updateSettings(this.settingsObject)
    // }
  },
  created () {
    this.getSettings()
  },
  components: { Editor, FooterItem, draggable },
  watch: {
    text () {
      this.handleUpdate()
    }
  },
  filters: {
    formatFileName (val) {
      return val.split('/').pop()
    }
  }
}
</script>

<style scoped>
.footer-menu-generator {
  margin: 15px 0;
}
.footer-menu-generator > div {
  width: 50%;
  padding: 0 10px;
}
.footer-menu-generator strong {
  margin: 5px 0 15px;
  display: inline-block;
  text-align: center;
  width: 100%;
}
.settings-files {
  margin: 5px 0 10px;
}
.settings-files p {
  margin: 5px 0;
}
.settings-files strong {
  margin: 0 5px 0 0;
}
.box {
  max-width: 700px;
  margin: 40px auto;
  cursor: initial;
}
h3 {
  font-size: 22px;
  font-weight: bold;
  text-align: center;
}
.social p {
  margin: 5px 0;
  align-items: center;
  display: flex;
}
.social .control {
  width: 100%;
}
.social img {
  width: 30px;
  height: 30px;
  margin: 0 15px 0 0;
}
.delete-document {
  cursor: pointer;
}
</style>
<style>
.settings-address textarea {
  max-height: 70px;
  min-height: 70px;
}
</style>



// WEBPACK FOOTER //
// Index.vue?6c6f169c